import classNames from 'classnames';
import { SelectHTMLAttributes } from 'react';
import formItemStyles from 'styles/BFormItem.module.css';
import selectStyles from 'styles/BSelect.module.css';
import { DropdownOption } from 'types/types';

export interface BSelectProps<T extends string | number>
  extends SelectHTMLAttributes<HTMLSelectElement> {
  options: DropdownOption<T>[];
  selectedValue: T;
}

function BSelect<T extends string | number>({
  options,
  selectedValue,
  className,
  ...attrs
}: BSelectProps<T>) {
  return (
    <select
      value={selectedValue}
      className={classNames(
        formItemStyles['b-form-item'],
        selectStyles['b-select'],
        className
      )}
      {...attrs}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}

export default BSelect;
